module.exports = __webpack_public_path__ + "static/media/webdesign-services-img5.10566f77.jpg";